var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "heng mr10" }),
          _c("div", { staticClass: "mr10" }, [
            _vm._v(_vm._s(_vm.headerConfig.title)),
          ]),
          _vm.headerConfig.time
            ? _c(
                "div",
                {
                  staticClass: "mr10 text-muted",
                  staticStyle: { "font-size": "14px" },
                },
                [
                  _vm._v(
                    " 更新时间: " +
                      _vm._s(new Date().Format("yyyy-MM-dd hh:mm:ss")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.headerConfig.text
            ? _c(
                "div",
                {
                  staticClass: "mr10 text-muted",
                  staticStyle: { "font-size": "12px" },
                },
                [_vm._v(" " + _vm._s(_vm.headerConfig.text) + " ")]
              )
            : _vm._e(),
          _vm.headerConfig.totalConfig
            ? _c(
                "el-popover",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    placement: "top-start",
                    title: "说明",
                    trigger: "hover",
                  },
                },
                [
                  _c("div", {
                    staticClass: "totalConfig mb10",
                    domProps: {
                      innerHTML: _vm._s(_vm.headerConfig.totalConfig),
                    },
                  }),
                  _c("div", {
                    staticClass: "mt5 info el-icon-question",
                    staticStyle: { flex: "1", color: "#8a8a8a" },
                    attrs: { slot: "reference" },
                    slot: "reference",
                  }),
                ]
              )
            : _c("div", { staticStyle: { flex: "1" } }),
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: { click: _vm.handleRightButtonClick },
            },
            [_vm._v(" " + _vm._s(_vm.headerConfig.rightBtnText) + " ")]
          ),
          _vm.timeShow
            ? _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.value1,
                  callback: function ($$v) {
                    _vm.value1 = $$v
                  },
                  expression: "value1",
                },
              })
            : _vm._e(),
          _vm.tabsShow
            ? _c(
                "div",
                { staticClass: "tabs" },
                _vm._l(_vm.itemData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "tabs-item",
                      class: { tabsActive: _vm.currentIndex == item.code },
                      on: {
                        click: function ($event) {
                          return _vm.handelEcharts(item.code)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.desc) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.exportShow
            ? _c(
                "div",
                { staticClass: "tabs" },
                [
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { cursor: "pointer" },
                      on: {
                        command: function ($event) {
                          return _vm.handleCommand($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "el-dropdown-link" }, [
                        _c("i", {
                          staticClass: "mt10 mb10 ml10 el-icon-s-operation",
                          staticStyle: { "font-size": "20px" },
                        }),
                      ]),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [_c("el-dropdown-item", [_vm._v("导出excel")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }